import { createSlice } from '@reduxjs/toolkit'
import Bowser from 'bowser'

import { goNextScreen } from './screenSlice'


export const COMMON_REDUCER_KEY = 'common'

const commonSlice = createSlice({
    name: COMMON_REDUCER_KEY,
    initialState: {
        isSafari: Bowser.getParser(window.navigator.userAgent).getBrowserName().toLowerCase() === 'safari',
        modalSown: false,
        volumeOn: true,
    },
    reducers: {
        toggleModal: (state) => {
            state.modalSown = !state.modalSown
        },
        toggleVolume: (state) => {
            state.volumeOn = !state.volumeOn
        },
    },
    extraReducers: {
        [goNextScreen.toString()]: (state) => {
            state.modalSown = false
        },
    },
})

export const {
    toggleModal,
    toggleVolume,
} = commonSlice.actions

const getState = state => state[COMMON_REDUCER_KEY]
export const getIsSafari = state => getState(state).isSafari
export const getIsModalShown = state => getState(state).modalSown
export const getIsVolumeOn = state => getState(state).volumeOn

export default commonSlice.reducer
